export default {
  /**
   * navigationBar 数据源
   */
  routerLang: (state) => state.lang.lang,
  isTransparent: (state) => state.isTransparent,
  isWhite: (state) => state.isWhite
}
